export * from './useMatchSingleObjectByDetectedBounding';
export { default as useMatchSingleObjectByDetectedBounding } from './useMatchSingleObjectByDetectedBounding';
